import styled from 'styled-components';

export const InputGroup = styled.div`
  display: flex;
`;
